import React from 'react';
import c from 'classnames';

import './style.scss';

const Loader = ({ loading, inline }) => {
  const loaderClasses = c('Loader', {
    'Loader--inline': inline,
    'Loader--absolute': !inline,
  });

  return (
    loading ? (
      <div className={loaderClasses} />
    ) : (
      <></>
    )
  );
};

export default Loader;
